// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
export default [
  {
    value: 1,
    name: "Practice",
    mode: "Practice",
    description:
      "Take the assessment as many times as you like and get automatic feedback right away."
  },
  {
    value: 2,
    name: "Test or Quiz",
    mode: "Graded Assessment",
    description: "Take it once and receive a grade after you've submitted."
  }
  // {
  //   value: 3
  //   name: "Survey"
  //   mode: 'Survey'
  //   description: "Give feedback by answering all of the questions."
  // }
]
